[
  {
    "label": "rangeFrom",
    "displayLabel": "From",
    "editable": true,
    "placeholder": "Enter Range From",
    "fieldInfo": {
      "dataType": "number"
    }
  },
  {
    "label": "rangeTo",
    "displayLabel": "To",
    "editable": true,
    "placeholder": "Enter Range To",
    "fieldInfo": {
      "dataType": "number"
    }
  },
  {
    "label": "numberOfPackages",
    "displayLabel": "Packages",
    "editable": false
  }
]
